<template>
  <div class="shop-bg scrollbar">
    <div class="container">
      <div class="shop-wrapper">
        <div class="shop-title d-inline-block">
          <h1>Shop</h1>
        </div>

        <div class="row">
          <div class="col-md-3">
            <section class="filter-wrapper">
              <div class="hideList" :class="openFiltersList ? 'showList' : ''">
                <div class="list-wrapper">
                  <label for="#" class="filter-title ms-2 my-2">Filters</label>
                  <ul class="schema-list">
                    <li>
                      <a
                        href="#"
                        :class="`${searchTerm == 'all' ? 'selected' : ''}`"
                        @click="filter('all')"
                        >Show All</a
                      >
                    </li>
                    <li>
                      <a
                        href="#"
                        :class="`${searchTerm == 'items' ? 'selected' : ''}`"
                        @click="filter('items')"
                        >Game Items</a
                      >
                    </li>
                    <li>
                      <a
                        href="#"
                        :class="`${searchTerm == 'food' ? 'selected' : ''}`"
                        @click="filter('food')"
                        >Food</a
                      >
                    </li>
                    <li>
                      <a
                        href="#"
                        :class="`${
                          searchTerm == 'characters' ? 'selected' : ''
                        }`"
                        @click="filter('characters')"
                        >Character</a
                      >
                    </li>
                    <li>
                      <a
                        href="#"
                        :class="`${searchTerm == 'guns' ? 'selected' : ''}`"
                        @click="filter('guns')"
                        >Guns</a
                      >
                    </li>
                    <li>
                      <a
                        href="#"
                        :class="`${searchTerm == 'packs' ? 'selected' : ''}`"
                        @click="filter('packs')"
                        >Packs</a
                      >
                    </li>
                    <li>
                      <a
                        href="#"
                        :class="`${searchTerm == 'pass' ? 'selected' : ''}`"
                        @click="filter('pass')"
                        >Pass</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </section>
          </div>
          <div class="col-md-9">
            <div class="add-button text-right mx-3" v-if="admin">
              <button
                class="btn btn-rounded px-4 my-3"
                @click="showMdl = !showMdl"
              >
                ADD
              </button>
              <MarketModal
                v-if="showMdl"
                v-on:w-modal-hide-click="showMdl = false"
              />
            </div>
            <section class="main-content-wrapper">
              <loading
                v-model:active="isLoading"
                :can-cancel="true"
                :is-full-page="false"
              />
              <div class="row">
                <div
                  class="col-md-6 col-lg-3"
                  v-for="(item, index) in info"
                  :key="index"
                >
                  <GameItem
                    :item="item"
                    v-if="item.ingame_item == 1"
                    v-on:refresh="init()"
                  />
                  <MarketItem :item="item" v-else v-on:refresh="init()" />
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import ApiService from "../services";
import "vue-loading-overlay/dist/vue-loading.css";
import GameItem from "../components/GameItem.vue";
import MarketItem from "../components/MarketItem.vue";
import Loading from "vue-loading-overlay";
import MarketModal from "../components/Modal/MarketModal.vue";
export default {
  name: "Market",
  components: {
    GameItem,
    Loading,
    MarketItem,
    MarketModal,
  },

  data() {
    return {
      selectedInfo: [],
      openFiltersList: true,
      isLoading: true,
      waxLoaded: false,
      showMdl: false,
      searchTerm: "all",
      apiRes: null,
      info: null,
      rarity: "all",
      admin: false,
    };
  },
  mounted() {
    this.init();
    this.admin = localStorage.getItem("wax_user");
    if (this.admin == process.env.VUE_APP_CONTRACT) {
      this.admin = true;
    } else {
      this.admin = false;
    }
  },
  methods: {
    init() {
      ApiService.market((res) => {
        this.info = res;
        this.apiRes = res;
        this.$store.commit("addMarket", this.info);
        this.isLoading = false;
      });
    },
    filter(term) {
      this.searchTerm = term;
      var foods = ["BEANS", "JERKY", "CBREAD", "FSTEW"];
      if (term == "items") {
        this.info = this.apiRes.filter((el) => el.ingame_item == 1);
        this.info = this.info.filter((el) => !foods.includes(el.schema));
      } else if (term == "food") {
        this.info = this.apiRes.filter((el) => el.ingame_item == 1);
        this.info = this.info.filter((el) => foods.includes(el.schema));
      } else if (term == "all") {
        this.info = this.apiRes;
      } else {
        this.info = this.apiRes.filter((el) => el.schema == term);
      }
    },
  },
};
</script>
  <style scoped>
.title {
  font-size: 25px;
  margin-top: 10px;
  font-weight: 600;
}

.shop-title h1 {
  font-weight: bold;
  text-transform: uppercase;
  color: #eeac33;
}

.filter-wrapper {
  overflow-y: auto;
  padding: 10px;
  border-radius: 10px;
  /*  height: 500px;*/
}
.info_btn:hover,
i {
  border-color: #d9dbe2;
  transition: all 0.4s;
}
.hideContent {
  display: none;
}
.card_img {
  height: 200px;
}
.card_img img {
  height: 100% !important;
}

.btn-filter {
  float: right;
  color: #fff !important;
  position: relative;
  top: -35px;
  display: none;
}
.card_footer .btn-buy {
  display: block;
}
.main-content-wrapper {
  overflow-y: auto;
  overflow-x: hidden;
  /* height: 850px; */
  padding-right: 10px;
  /* padding-bottom: 70px; */
  padding: 10px;
  border-radius: 10px;
}
.schema-list .selected {
  background: #01253d;
}
.card_footer input {
  border-radius: 1.25rem;
}
.filter-button {
  float: right;
}
.filter-button button {
  background: #eeac33;
  padding: 4px 16px !important;
  border-radius: 8px;
  border: none;
  color: var(--mainWhite);
}
</style>
  